export default __webpack_public_path__ + "static/media/convenience.91e325b2.png";